// common
import {
  getModule,
  VuexModule,
  Mutation,
  Module,
} from "vuex-module-decorators";
import store from "@/store";

//helpers
// import { IScannerUsage } from "@/interfaces/scanner/scanner";
// import { IPOSConfigState } from "@/interfaces/store/IPOSConfig";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "ScannerConfiguration",
})
class ScannerConfiguration extends VuexModule {
  public value = "";
  public listeners = 0; // how many are listenting
  public tog = false;

  get singleListenerOnly() {
    return this.listeners === 1;
  }

  get noListeners() {
    return this.listeners === 0;
  }

  @Mutation
  public setValue(val: string) {
    this.value = val;
  }

  @Mutation
  public addListener() {
    this.listeners = this.listeners + 1;
  }

  @Mutation
  public removeListener() {
    this.listeners = this.listeners - 1;
  }

  @Mutation
  public toggle() {
    this.tog = !this.tog;
  }
}
const ScannerModule = getModule(ScannerConfiguration);
export default ScannerModule;
